import React from "react"
import MUIDataTable from "mui-datatables";
import LoadingState from '../LoadingState'

const DataTable = ({ loading = false, error, ...props }) => {
    if (error || loading) return <LoadingState title={props.title} error={error} />
    const defaultOptions = {download:false,print:false,viewColumns:false,selectableRows:"none",rowsPerPageOptions:[5,10,25,100]}    
    const mergedOptions = Object.assign(defaultOptions,props.options)
    return (
        <MUIDataTable {...props} options={mergedOptions} />
    )
}

export default DataTable
